import { render } from "./ResponseRateSegmentQuestion.vue?vue&type=template&id=35200f84"
import script from "./ResponseRateSegmentQuestion.vue?vue&type=script&lang=js"
export * from "./ResponseRateSegmentQuestion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__